import {
    Box,
    Dialog,
    Tooltip,
    DialogContent,
    Typography,
    DialogTitle,
    Grid,
    IconButton,
  } from "@mui/material";
  import { Form, Formik } from "formik";
  import * as yup from "yup";
  //uuid generator
  import { v4 as uuidv4 } from "uuid";
import useAuth from "../../../hooks/useAuth";
import React, { useEffect, useRef, useState } from "react";
import useMutationAuth from "../../../hooks/useMutationAuth";
import { MOVE_TIME_ENTRY } from "../../../graphql/timeEntry";
import { GET_ALL_TASKS_WITH_PROJECT,GET_TASKS_BY_PROJECT_DROPDOWN } from "../../../graphql/task";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../graphql/project";
import PaperComponent from "../../../components/Modal/PaperComponent";
import AutoComplete from "../../../components/AutoComplete";
import { enqueueSnackbar } from "notistack";
import { CloseIcon, MoveIcon } from "../../../components/Icon";
import colors from "../../../assets/theme/light/colors";
import IALoadingButton from "../../../components/IAButtons/IALoadingButton";
import useQueryAuth from "../../../hooks/useQueryAuth";
import useLazyQueryAuth from "../../../hooks/useLazyQueryAuth";
  
  const MoveTimeEntryModal = ({
    openDialog,
    handleClose,
    setSelectedTimeEntry,
    t,
    selectedTimeEntry,
    fromTimesheet = false,
    refetechTask,
    changeNewlyOpen,
    setFromTimesheet,
    callButton,
  }) => {
    const wait = false;
    const formField = {
      project: {
        name: "project",
        label: "taskModal.project.label",
        requiredMessage: "taskModal.project.requiredMessage",
      },
      task: {
        name: "task",
        label: "timeEntry.targetTask.label",
        requiredMessage: "taskModal.task.requiredMessage",
      },
    };
  
    const { project, task } = formField;

    const [taskId, setTaskId] = useState(null)
  
    const validationSchema = yup.object({
      project: yup.object().required(project.requiredMessage),
      task: yup.object().required(task.requiredMessage),
    });
    const [selectedProject, setSelectedProject] = React.useState(null);
  
    const initialValues = {
      project: null,
      task: null,
    };
  
    const { storeUserTenant, storeUserGuid } = useAuth();
    const newlyOpened = useRef(true);
    const [changed, setChanged] = useState(false);

  
    const [fetchProjects, setFetchProjects] = useState(false);
    const [fetchTickets, setFetchTickets] = useState(false);
    const [fetchTasks, setFetchTasks] = useState(false);
  
    const formikValuesRef = useRef(null);
    const formikRef = useRef(null);
    const [showSubTasks, setShowSubTasks] = useState(true);
  
    useEffect(() => {
      const handleKeyDown = (event) => {
        // Check for Ctrl + S
        if (event.key === 's' && event.ctrlKey) {
          event.preventDefault(); // Prevent the default behavior
          formikRef.current?.handleSubmit(formikValuesRef.current); // Submit the form
        }
      };
    
      window.addEventListener('keydown', handleKeyDown);
    
      // Clean up the event listener on unmount
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);
  
    useEffect(() => {
      newlyOpened.current = true;
    }, [changeNewlyOpen])
  
    const { cfunction: moveTimeEntry } = useMutationAuth(MOVE_TIME_ENTRY, "MoveTimeEntry");
  
    const {
      data: projectData,
      loading: projectLoading,
      tokenChange: projectWait,
    } = useQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects", {
      variables: {
        model: {
          enableFilters: false,
          tenantID: storeUserTenant,
          userID: storeUserGuid,
        },
      },
      skip: !openDialog || wait || !fetchProjects,
      isWait: fetchProjects,
    });
    const [task_list, setTasksList] = React.useState([]);
    const {
        mfunction: getTasksWithProject,
        loading: tasksLoading,
        tokenChange: taskWait,
      } = useLazyQueryAuth(GET_TASKS_BY_PROJECT_DROPDOWN, "GetTasksByProject");

      useEffect(() => {
        if (selectedProject) {
          getTasksWithProject(
            {
              variables: {
                model: {
                  userID: storeUserGuid,
                  activeTask: false,
                 // onGoingTasks: true,
                  userID: storeUserGuid,
                  projectID: selectedProject,
                //  timeEntriesCreationAllowed: true,
                },
              },
            },
            (response) => {
              setTasksList(response?.GetTasksByProject?.tasks || []);
            }
          );
        }
      }, [selectedProject]);
      const parentTasks = task_list.reduce((acc, task) => {
        if (!task.parentTaskGuid ) {
          // Check if parentTaskGuid is null
          acc.push(task);
        }
        return acc;
      }, []);
      const groupTasks = (tasks) => {
        const grouped = {};
    
        tasks.forEach((task) => {
          if (!task.parentTaskGuid) {
            grouped[task.taskGuid] = { ...task, children: [] };
          }
        });
    
        tasks.forEach((task) => {
          if (task.parentTaskGuid && grouped[task.parentTaskGuid]) {
            grouped[task.parentTaskGuid].children.push(task);
          }
        });
    
        return Object.values(grouped).flatMap((parent) => [
          { ...parent, isParent: true },
          ...parent.children.map((child) => ({ ...child, isChild: true })),
        ]);
      };
 
    const projects_list =
      projectData?.GetAllProjects?.projectsList?.projectViews || [];

      function createEntries(selectedTimeEntries, taskId, tenantGuid) {
        return selectedTimeEntries.map(timeEntryID => ({
          taskID: taskId,
          timeEntryID: timeEntryID,
          tenantGuid: tenantGuid
        }));
      }

    const entries = createEntries(selectedTimeEntry, taskId, storeUserTenant)
  
    const handleSubmit = (values, actions) => {
    //   if(values[task.name].allowCreateTimeEntry!==true){
                             
    //     enqueueSnackbar(t("timeEntry.move.error.taskNotAlowed"), {
    //       variant: "error"
    //     });
    //     actions.setSubmitting(false);
    // return
    //   }
        moveTimeEntry(
         { variables: {
            model: {
              moveList : entries,
              userID: storeUserGuid,
            },
          },
         }, (response) => {
          if (
            response["MoveTimeEntry"].errorCode !== null &&
            response["MoveTimeEntry"].errorCode !== ""
          ) {
            enqueueSnackbar(t(response["MoveTimeEntry"].errorMessage), {
              variant: "error",
              autoHideDuration: 5000,
            });
            actions.setSubmitting(false);
            setSelectedTimeEntry([])
            handleClose()
          } else {
            enqueueSnackbar(t("taskForm.movedSuccessfully"), {
              variant: "success",
            });
            setSelectedTimeEntry([])
            handleClose()
            if(refetechTask){
              refetechTask()
            }
            if(fromTimesheet){
                callButton()
            }
          }
          actions.setSubmitting(false);
        }, (error) => {
          actions.setSubmitting(false);
          handleClose()
          setSelectedTimeEntry([])
          enqueueSnackbar(t('Error processing your request'), {
            variant: "error"
          });
        });
      };
      
    return (
      <Dialog
        open={openDialog}
        onClose={() => {
          setChanged(false);
          if(fromTimesheet === true){
            setFromTimesheet(false)
          }
          // newlyOpened.current = true;
          handleClose();
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{
            cursor: "move",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          id="draggable-dialog-title"
        >
          <div>
            <MoveIcon color={colors.icon_button_grey} />
            <span style={{ marginLeft: "5px" }}>
              {t("taskModal.label.moveTo")}
            </span>
          </div>
          <IconButton
            onClick={() => {
                
              setChanged(false);
              // newlyOpened.current = true;
              if(fromTimesheet === true){
                setFromTimesheet(false)
              }
              handleClose();
            }}
          >
            <CloseIcon color={"#9e9e9e"} width={"24"} stroke={"1.5"} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Formik
            innerRef={formikRef}
            key={`move-task`}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              setFieldValue,
              setTouched,
            }) => {
              if (newlyOpened.current === true) {
                setFieldValue(
                  project.name,
                 null
                );
                setFieldValue(task.name, null);
                newlyOpened.current = false;
              }
              const formData = {
                values,
                errors,
                touched,
                isSubmitting,
                setFieldValue,
                setTouched,
              };
              formikValuesRef.current = values;
              return (
                <Form
                  id={`move-time-entry-${uuidv4()}`}
                  autoComplete="off"
                  // onChange={() => {
                  //   if (touched) {
                  //     sessionStorage.setItem(
                  //       "unsavedChanges",
                  //       JSON.stringify(true)
                  //     );
                  //   }
                  // }}
                >
                  <Box p={2}>
                    <Box>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <AutoComplete
                            options={projects_list}
                            getOptionLabel={(option) =>
                              option ? option.title : ""
                            }
                            renderOption={(props, option) => (
                              <li {...props} key={uuidv4()}>
                                {option.title}
                              </li>
                            )}
                            identifier={"projectGuid"}
                            value={
                              values[project.name]
                            }
                            onChange={(e, value) => {
                              setFieldValue(project.name, value);
                            //   setProjectGuid(value?.projectGuid);
                              setSelectedProject(value?.projectGuid)
                              setFieldValue(task.name, null);
                              setChanged(true);
                            }}
                            onOpen={() => setFetchProjects(true)}
                            onClose={() => setFetchProjects(false)}
                            required
                            loading={projectLoading}
                            label={t(project.label)}
                            name={project.name}
                            formData={formData}
                            disableFormChanged
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container  spacing={1} direction="row">
                      <Grid item xs>    <AutoComplete
                        //
                          options={showSubTasks
                            ? groupTasks(task_list)
                            : parentTasks}
                      
                          getOptionLabel={(option) =>
                            option ? option.title : ""
                          }
                          renderOption={(props, option) =>  showSubTasks ? (
                            <li
                              {...props}
                              style={{
                                paddingLeft: option.isChild
                                  ? 20
                                  : 5,
                              }}
                            >
                              <Typography
                                variant="body2"
                                style={{
                                  fontWeight: option.isChild
                                    ? "normal"
                                    : "bold",
                                }} // Bold for parent tasks
                              >
                                {option.title}
                              </Typography>
                            </li>
                          ) : (
                            <li {...props} key={uuidv4()}>
                              {option.title}
                            </li>
                          )}
                          identifier={"taskGuid"}
                          value={
                            values[task.name]
                          }
                          onChange={(e, value) => {
                            setFieldValue(task.name, value);
                            setTaskId(value?.taskGuid)
                          }}
                          onOpen={() => setFetchTasks(true)}
                          onClose={() => setFetchTasks(false)}
                          // loading={taskLoading}
                          label={t(task.label)}
                          name={task.name}
                          formData={formData}
                          disableFormChanged
                        />
                     </Grid>
                        
                        <Grid item display="flex">    
                        <span
                                        style={{
                                          paddingTop: "20px",
                                        }}
                                      >
                                        <Tooltip
                                          title={
                                            !showSubTasks
                                              ? t(
                                                  "taskForm.btn.showSubTasks.label"
                                                )
                                              : t(
                                                  "taskForm.btn.hideSubTasks.label"
                                                )
                                          }
                                           placement="right"
                                        >
                                          <svg
                                            fill="none"
                                            width="24"
                                            height="24"
                                            strokeWidth="2"
                                            viewBox="-3 -3 30 30"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                              setShowSubTasks(!showSubTasks);
                                              
                                            }}
                                          >
                                            <g
                                              stroke={
                                                showSubTasks
                                                  ? colors.light_logo_blue
                                                  : colors.icon_button_grey
                                              }
                                            >
                                              <path d="M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"></path>{" "}
                                              <path d="M18 4v17"></path>{" "}
                                              <path d="M15 18l3 3l3 -3"></path>
                                            </g>
                                          </svg>
                                        </Tooltip>
                                      </span>
                                      </Grid>
                     
                     </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      mt={2}
                      width="100%"
                      display="flex"
                      justifyContent="flex-end"
                    >
                      <IALoadingButton
                        disabled={isSubmitting}
                        loading={isSubmitting}
                        type="submit"
                        label={t("taskForm.save")}
                      />
                    </Box>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default MoveTimeEntryModal;
  